interface RelatedService {
  title: string;
  description: string;
  link: string;
  icon: string;
}

interface RelatedPassportServicesProps {
  services: RelatedService[];
  colorClass?: string;
  bgClass?: string;
  borderClass?: string;
  linkColorClass?: string;
}

export default function RelatedPassportServices({
  services,
  colorClass = "text-foreground-950",
  bgClass = "bg-background-100",
  borderClass = "border-background-200",
  linkColorClass = "text-foreground-700",
}: RelatedPassportServicesProps) {
  return (
    <section className={`${bgClass} py-14 md:py-18`}>
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] mb-2" style={{ color: "var(--secondary-500, #6B7280)" }}>
            Also Available
          </p>
          <h2 className={`text-2xl md:text-3xl font-bold ${colorClass}`}>
            Related Passport Services
          </h2>
          <p className="text-foreground-600 text-sm mt-2 max-w-xl mx-auto">
            Not exactly what you need? Here are other ways Fast Passport Center can help with your passport situation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {services.map((service, i) => (
            <a
              key={i}
              href={service.link}
              className={`group flex items-start gap-4 p-5 rounded-lg border ${borderClass} bg-white hover:shadow-md transition-all cursor-pointer`}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-full ${bgClass} flex-shrink-0`}>
                <i className={`${service.icon} text-lg ${linkColorClass}`}></i>
              </div>
              <div>
                <h3 className={`font-bold text-base group-hover:underline ${colorClass}`}>
                  {service.title}
                </h3>
                <p className="text-foreground-600 text-sm mt-1 leading-relaxed">
                  {service.description}
                </p>
              </div>
              <div className="flex-shrink-0 self-center ml-auto opacity-0 group-hover:opacity-100 transition-opacity">
                <i className={`ri-arrow-right-line ${linkColorClass}`}></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}